import React from "react"
import { Box } from "@mui/material"
import styles from "./ModalDefault.module.scss"
/**
 * ご確認方法モーダル
 */
const ModalConfirmation = () => {
  return (
    <>
      <Box className={styles.modalImage}>
        <img alt="shaken_info" src="./shaken_info.jpg" />
        <p>車検証から上記の項目をご確認ください。</p>
        <p>「型式」については、DBA-などのハイフン（-）より前の部分を省略してご入力ください。</p>
      </Box>
    </>
  )
}

export default ModalConfirmation
